/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { StoreApi, UseBoundStore } from 'zustand';
import { ButtonProps } from '../Button';
import { SdsDivProps } from '../Component.props';
import { OverlayProps, OverlayStore } from '../Overlay';
import { DropdownSectionData } from './Dropdown.defs';
import { DropdownPositionType } from './Dropdown.types';

/**
 * The props for `<DropdownMenu />`.
 */
export interface DropdownMenuProps extends SdsDivProps {
  /**
   * The props for the button that opens the Dropdown.
   */
  buttonProps: ButtonProps;

  /**
   * Custom heading markup for the dropdown.
   */
  customHeading?: React.ReactNode;

  /**
   * The Dropdown position.
   */
  dropdownPosition: DropdownPositionType;

  /**
   * The heading of the dropdown.
   */
  heading?: string;

  /**
   * Close handler.
   */
  onClose?(): void;

  /**
   * Open handler.
   */
  onOpen?(): void;

  /**
   * The state store to handle the appearance of the overlay. Only applicable if trying to toggle the overlay.
   */
  overlayStateHandler?: UseBoundStore<StoreApi<OverlayStore>>;

  /**
   * The list of dropdown sections.
   */
  sections: Array<DropdownSectionData>;

  /**
   * If non-null, the dropdown state will determine if the overlay is displayed.
   */
  toggleOverlay?: OverlayProps | null;

  /**
   * Trigger the close action from a parent component.
   */
  triggerClose?: boolean;
}

/**
 * The default prop values for `<Dropdown />`.
 */
export const dropdownDefaults = {
  buttonProps: {
    label: `Toggle dropdown`,
  },
  toggleOverlay: null,
};
